import { render, staticRenderFns } from "./PIDTao.vue?vue&type=template&id=e8294e94&scoped=true"
import script from "./PIDTao.vue?vue&type=script&lang=js"
export * from "./PIDTao.vue?vue&type=script&lang=js"
import style0 from "./PIDTao.vue?vue&type=style&index=0&id=e8294e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8294e94",
  null
  
)

export default component.exports